import api from './api'

const baseUrl = '/drivers'
const part = (part) => `${part ? '/' + part : ''}`
const url = (...parts) => baseUrl + parts.map(part).join('')

// https://fonixtelematics.atlassian.net/wiki/spaces/DLC/pages/33751041/API

const dataOrDefault = (request, defData) => (request.data || defData)
// const toArray = (request) => dataOrDefault(request, [])

export default {

  self () {
    return api.get(url('self')).then(dataOrDefault)
  },

  updateSelf (driver) {
    return api.put(url('self'), driver)
  },

  get (id) {
    return api.get(url(id)).then(dataOrDefault)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/drivers.js